<!-- 
	This is the Orders List page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>

	<div>
        <a-row>
            <a-col :span="10">
                <a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: '20px'}">
                    <p>Nama Koas</p>
                    <h6 class="font-semibold">{{ data.koas_resident_name }}</h6>
                </a-card>
            </a-col>
        </a-row>


		<a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: '20px'}" style="padding-top: 40px">
            <div style="position: absolute; left: 10px; top: 10px; z-index: 10; display: flex; flex-direction: column; align-items: start">
                <a-button @click="getData()" class="no-shadow">
                    <a-icon type="reload"></a-icon>
                </a-button>
            </div>

            <a-timeline>
                <a-timeline-item v-for="r in data.log"
                                 :color="r.trx_status.endsWith('request') ? 'blue' : r.trx_status.endsWith('accepted') ? 'green' : 'red'"
                >
                    <div>
                        <span class="timeline-date">{{ formatTanggal(r) }}</span>
                        <span class="timeline-status"><span v-if="r.is_partner == 1" style="color: #c45959;">[Partner]<br/></span>{{ statusByCode(r.trx_status) }}</span>
                        <span v-if="r.description" class="timeline-desc" style="white-space: pre">{{ r.description }}</span>
                    </div>
                </a-timeline-item>
            </a-timeline>

		</a-card>
		
	</div>

</template>

<script>

	// Sorting function for string attibutes.
	import BookingApi from "../../repository/api/BookingApi";
    import { dateFormatIndoWithTime } from "../../utils/Extenstion";

    let stringSorter = function(a, b, attr) {
		if (a[attr] < b[attr])
			return -1;
		if ( a[attr] > b[attr])
			return 1;
		return 0;
	}

	export default {
		data() {
			return {
				data: {},
                statusMap: [],
				
				// Table search query
				query: '',

			}
		},

        async mounted() {
            this.getStatus()
            this.getData()
        },

		computed: {

		},

		methods: {
            getStatus() {
                BookingApi.getStatus()
                    .then((response) => {
                        this.statusMap = response
                    })
                    .catch((e) => {
                        this.$swal({
                            icon: e.severity || "error",
                            title: (e.severity || "error").toUpperCase(),
                            text: e.message,
                        });
                    })
            },

            getData() {
                BookingApi.get(this.$route.params.id)
                    .then((response) => {
                        console.log(response)
                        this.data = response
                    })
                    .catch((e) => {
                        this.$swal({
                            icon: e.severity || "error",
                            title: (e.severity || "error").toUpperCase(),
                            text: e.message,
                        });
                    })
            },

            statusByCode(code) {
                const s = this.statusMap.find(x => x.code === code)
                return s ? s.description : '-'
            },

            formatTanggal(row) {
                return dateFormatIndoWithTime(row.created_at)
            },
		},
	}

</script>

<style lang="scss" scoped>

    .timeline-date {
        display: block;
        color: #888888;
        font-weight: normal;
    }

    .timeline-status {
        display: block;
    }

    .timeline-desc {
        display: block;
        font-weight: normal;
        font-size: 13px;
    }

</style>